export default __webpack_public_path__ + "static/media/Graphics_Mike-02-min.d8490cd3.jpg";